<ll-titulo>Mis carreras de interés</ll-titulo>

<buscador-carreras (seguirEvent)="misCarreras.loadPreferenciaCarreras()" [withPais]="withPais"></buscador-carreras>
<br />
<mis-carreras #misCarreras [hidePuntajesPromedio]="hidePuntajesPromedio"></mis-carreras>
<carreras-terminos-modal *ngIf="withTerminosCarreras"></carreras-terminos-modal>
